import { render, staticRenderFns } from "./MarcaShow.vue?vue&type=template&id=7ab5ba87&"
import script from "./MarcaShow.vue?vue&type=script&lang=js&"
export * from "./MarcaShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports